// extracted by mini-css-extract-plugin
export default {"infoRow":"BatchCreditOnsCheck__infoRow--_vslwz2o2tPLCTzl5kiA"};